import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import PT from 'prop-types';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';
import { T as Text } from '../Text/Text-0931b9fc.js';

const TagComponent = ({
  className,
  label,
  type,
  description,
  ...rest
}) => /*#__PURE__*/React__default.createElement("span", _extends({
  className: className
}, rest), /*#__PURE__*/React__default.createElement(Text, {
  type: "sr-only"
}, description), /*#__PURE__*/React__default.createElement("span", {
  "aria-hidden": "true"
}, label));
TagComponent.propTypes = {
  className: PT.string,
  label: PT.node,
  type: PT.oneOf(['new', 'beta']),
  description: PT.string
};
TagComponent.defaultProps = {
  className: '',
  label: 'New',
  type: 'new',
  description: 'New'
};
const Tag = /*#__PURE__*/styled(TagComponent).withConfig({
  componentId: "sc-storm-ui-30037988__sc-osvndd-0"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";margin:", ";display:inline-block;position:relative;bottom:", ";background:", ";padding:", ";border-radius:", ";", ""], ({
  theme
}) => theme.tag.fontSize, ({
  theme
}) => theme.tag.fontWeight, ({
  theme
}) => theme.tag.lineHeight, ({
  theme
}) => theme.tag.color, ({
  theme
}) => theme.tag.margin, ({
  theme
}) => theme.tag.bottomOffset, ({
  theme,
  type
}) => {
  switch (type) {
    case 'new':
      return theme.tag.backgroundNew;
    default:
      // Default to the beta tag color
      return theme.tag.backgroundBeta;
  }
}, ({
  theme
}) => theme.tag.padding, ({
  theme
}) => theme.tag.radius, isMobile(css(["font-size:", ";line-height:", ";margin:", ";"], ({
  theme
}) => theme.tag.mobile.fontSize, ({
  theme
}) => theme.tag.mobile.lineHeight, ({
  theme
}) => theme.tag.mobile.margin)));
Tag.displayName = 'Tag';
Tag.propTypes = {
  /**
   * Use this prop to provide localized tag labels in internationalized UIs.Refer to [string translations for “beta”](https://translator.amazon.com/search/strings?tag=ucb_beta_feature&exact_match=on&text=&stage%5Bprod%5D=prod&locale_invert=false&locale=-1&marketplace_invert=false&marketplace=-1&team_invert=false&group=-1&stringset_invert=false&set=-1&query_id=&show_advanced=0), [string translations for “new”](https://translator.amazon.com/search/strings?tag=ucb_new_tag&exact_match=on&text=&stage%5Bprod%5D=prod&locale_invert=false&locale=-1&marketplace_invert=false&marketplace=-1&team_invert=false&group=-1&stringset_invert=false&set=-1&query_id=&show_advanced=0).
   */
  label: PT.node,
  /**
   * Defines the background color and default label
   */
  type: PT.oneOf(['new', 'beta']),
  /**
   * Use this prop to provide localized tag description in internationalized UIs. This will be read
   * when a screen reader encounters a tag.
   */
  description: PT.string
};
Tag.defaultProps = {
  label: 'New',
  type: 'new',
  description: 'New'
};
var Tag$1 = Tag;

export { Tag$1 as T };
//# sourceMappingURL=Tag-2f585834.js.map
